import React, {FC, useRef} from 'react';
import { inputProps as InputProps } from '../../types/types';
import {
    PhoneInput,
    defaultCountries,
    parseCountry,
} from 'react-international-phone';
import 'react-international-phone/style.css';
import { getBookingConfig } from '../../data/price';

interface PhoneInputFieldProps extends InputProps {
    value: string,
    placeholder: string,
    typeOverride?: string,
    onChangeString: (value: string) => void
}

const PhoneInputField: FC<PhoneInputFieldProps> = ({
    value,
    placeholder,
    label,
    labelText,
    onChange,
    required,
    redHighlight,
    additionalClassNames,
    additionalNote,
    useLabelTextAsHtml,
    typeOverride, // For if there's no other change in HTML
    onChangeString,
    // refList,
    // refIndexByLabel
}) => {
    const config = getBookingConfig();

    const supportedIso2 = [
        'be',
        'nl',
        'fr',
        'de',
        'es',
        'lu',
    ];

    const supportedCountries = defaultCountries.filter((country) => {
        const { iso2 }  = parseCountry(country);
        return supportedIso2.includes(iso2);
    });

    function defaultCountry() {
        if (config.country && supportedIso2.includes(config.country)) {
            return config.country;
        } else {
            return 'be';
        }
    }


    return (
        <div
            className={
                "mb-3 w-full " + (additionalClassNames ?? "")
                + (redHighlight ? " required-highlight" : "").replace("  ", " ")
            }
            
        >
            <label htmlFor={label}
                    className="form-label inline-block mb-2 text-gray-700">
                {labelText}
                {required &&
                    <span className="text-red-500 font-bold text-2xl">*</span>
                }
            </label>
            <PhoneInput
                name={label}
                defaultCountry={defaultCountry()}
                value={value}
                countries={supportedCountries}
                forceDialCode
                onChange={(phoneNumber) => onChangeString(phoneNumber)}
                className="
                    form-control block w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding
                    rounded
                    m-0 lg:mr-8
                    focus:shadow-none
                    focus:text-gray-700 focus:bg-white focus:border-amber-400 focus:outline-none
                "
                inputClassName="
                    form-control block w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding
                    rounded
                    m-0 lg:mr-8
                    focus:shadow-none
                    focus:text-gray-700 focus:bg-white focus:border-amber-400 focus:outline-none
                "
            />
            {additionalNote !== undefined && <p>{additionalNote}</p>}
        </div>
    );
};

export default PhoneInputField;